import Phaser from "phaser";
import { GAME_WIDTH } from "../constants";
import { addPanel, dimScene } from "../ui/chrome";
import { MenuButton, bindMenuKeys } from "../ui/MenuButton";
import { titleStyle } from "../ui/theme";
import { audioManager } from "../systems/AudioManager";

export class PauseScene extends Phaser.Scene {
  constructor() {
    super({ key: "Pause" });
  }

  create(): void {
    this.cameras.main.setBackgroundColor({ r: 0, g: 0, b: 0, a: 0 });
    dimScene(this, 0.62).setDepth(1);
    addPanel(this, GAME_WIDTH / 2, 348, 400, 300).setDepth(2);
    this.add
      .text(GAME_WIDTH / 2, 250, "Paused", titleStyle(40))
      .setOrigin(0.5)
      .setColor("#2a1a10")
      .setStroke("#000000", 0)
      .setDepth(3);

    const resume = new MenuButton(this, GAME_WIDTH / 2, 338, "Resume", () => this.resumeRun());
    const quit = new MenuButton(
      this,
      GAME_WIDTH / 2,
      414,
      "Return to Menu",
      () => {
        audioManager.resumeOutput();
        this.scene.stop("Pause");
        this.scene.stop("Game");
        this.scene.start("Menu");
      },
      236,
      "secondary",
    );
    resume.container.setDepth(3);
    quit.container.setDepth(3);
    bindMenuKeys(this, [resume, quit]);
    this.input.keyboard?.on("keydown-ESC", () => this.resumeRun());
  }

  private resumeRun(): void {
    audioManager.playSfx("ui-confirm");
    this.scene.stop("Pause");
    this.scene.resume("Game");
  }
}
